import {onlyDigitsPipe} from '../pipes';

export const isEsiaSnilsMatching = (
  esia: {snils?: string | null} | null | undefined,
  other: string | {snils?: string | null} | null | undefined,
) => {
  const left = onlyDigitsPipe(esia?.snils ?? '');
  const right = onlyDigitsPipe((typeof other === 'string' ? other : other?.snils) ?? '');
  return Boolean(left && right && left === right);
};
